import axios from 'axios'
import useSWR from 'swr'

export interface BlogPost {
  id: number
  title: string
  slug: string
  content: string
  excerpt: string
  imageUrl?: string
  status: string
  publishedAt: string
  authorName: string
  authorPosition: string
  authorImage?: string
  createdAt: string
  updatedAt: string
}

interface BlogResponse {
  success: boolean
  data: BlogPost[]
  pagination: {
    page: number
    limit: number
    totalPosts: number
    totalPages: number
  }
}

// Custom fetcher function using axios
const axiosFetcher = async (url: string) => {
  const response = await axios.get<BlogResponse>(url)
  return response.data
}

export function useBlogs() {
  const { data, error, isLoading } = useSWR<BlogResponse, Error>(
    'https://api.ipdcgroup.com/posts',
    axiosFetcher,
  )

  return {
    blogs: data?.data || [],
    pagination: data?.pagination,
    isLoading,
    isError: error,
  }
}
